import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import { Image, Table, Modal, Form, Button, Col, Row } from "react-bootstrap";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Alert from "react-s-alert";
import SuperAdminAddMerchantRequest from "./SuperAdminAddMerchantRequest";
import { FilterSearchSortDownload } from "../SuperAdminUOMServices/FilterSearchSortDownload/FilterSearchSortDownload";
import moment from "moment";
import { PromotionTableHead } from "./InsideTableHeadBody/PromotionTableHead";
import PromotionTableBody from "./InsideTableHeadBody/PromotionTableBody";
import { useFormik } from "formik";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getSubCateogryWithCategoryId } from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import {
  admin_get_requested_merchant_promotion,
  admin_delete_requested_promotion,
} from "../../../../store/actions/SuperAdminActions/superAdminMerchantPromotion";
import isEmpty from "../../../../store/validation/is-Empty";
import { MERCHANT_PROMOTION_STATUS } from "../../../../enums/GlobalEnums";
import NoContent from "../../../reusableComponents/NoContentComponent";

const SuperAdminMerchantPromotion = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState("");
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const token = props.auth.user.accessToken;
  const [page, setPage] = useState(
    props?.merchantPromotionPage?.page !== undefined
      ? props?.merchantPromotionPage?.page
      : 1
  );
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(
    props?.merchantPromotionPage?.per_page !== undefined
      ? props?.merchantPromotionPage?.per_page
      : 10
  );
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    // var calcStart = pageNo * 10 - 10;
    // setStart(calcStart);
    // setEnd(pageNo * 10);
    // setPage(pageNo);
    //page = pageNo;
    dispatch(
      admin_get_requested_merchant_promotion(
        token,
        pageNo,
        end,
        false,
        dateQuery,
        () => onSuccessPagination(),
        true,
        0,
        formik.values.requestedTag !== "" ? true : false,
        formik.values.promotionType !== "" ? true : false,
        formik.values.requestedTag,
        formik.values.promotionType
      )
    );
  };

  const onSuccessPagination = () => {
    setLoading(false);
  };

  /********************************
   * First Time Load Data
   ********************************/
  const [loading, setLoading] = useState(false);
  const [promotionType, getPromotionType] = useState([]);
  const [restaurantTags, getRestaurantTags] = useState([]);
  const [requestPromotion, setRequestPromotion] = useState([]);
  useEffect(() => {
    const promotionType = "62114b735ccac51d80d70810";
    const restaurantTags = "62114cff5ccac51d80d70b43";

    /********** @DESC GET PROMOTION TYPE **********/
    dispatch(
      getSubCateogryWithCategoryId(onSuccessGetPromotionType, promotionType)
    );
    /********** @DESC GET RESTAURANT TAGS **********/
    dispatch(
      getSubCateogryWithCategoryId(onSuccessGetRestaurantTags, restaurantTags)
    );
  }, []);

  /******************************
   * @DESC GET PROMOTION TYPE
   ******************************/
  const onSuccessGetPromotionType = (data) => {
    var subC = [];
    for (var i = 0; i < data.length; i++) {
      subC.push({
        icon_code: data[i].icon_code,
        name: data[i].title,
        id: data[i]._id,
        status: data[i].status,
        icon: data[i].icon,
        description: data[i].description,
      });
    }
    getPromotionType(subC);
    setLoading(false);
  };
  /******************************
   * @DESC GET RESTAURANT TAGS
   ******************************/
  const onSuccessGetRestaurantTags = (data) => {
    var subC = [];
    for (var i = 0; i < data.length; i++) {
      subC.push({
        icon_code: data[i].icon_code,
        name: data[i].title,
        id: data[i]._id,
        status: data[i].status,
        icon: data[i].icon,
        description: data[i].description,
        hexColor: data[i].hexColor,
      });
    }
    getRestaurantTags(subC);
    setLoading(false);
  };

  const [state, setState] = useState({
    displaySearch: false,
    displayFilter: false,
    filterApply: false,
    displayDeleteModal: false,
    search: "",
  });

  /***********************************
   * @DESC SEARCH INPUT
   ***********************************/
  const onClickSearch = (e) => {
    e.preventDefault();
    setState({
      ...state,
      displaySearch: !state.displaySearch,
      displayFilter: false,
    });
  };
  const onChangeSearch = (e) => {
    e.preventDefault();
    setState({
      ...state,
      search: e.target.value,
    });
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const userFilter = [
    { title: "A-Z", disabled: false },
    { title: "Z-A", disabled: false },
    { title: `Date & Time 🠑`, disabled: false },
    { title: "Date & Time 🠓", disabled: false },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onClickSetUserSort = (title) => {
    setUserSort(title);
    setAnchorEl(null);
  };

  /***********************************
   * @DESC Date Change Filter Action
   ***********************************/
  const onDateChangeHandler = (data) => {
    setDateQuery(data);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      setLoading(true);
      dispatch(
        admin_get_requested_merchant_promotion(
          token,
          page,
          end,
          false,
          dateQuery,
          () => onSuccessPagination(),
          true,
          0,
          formik.values.requestedTag !== "" ? true : false,
          formik.values.promotionType !== "" ? true : false,
          formik.values.requestedTag,
          formik.values.promotionType
        )
      );
    }
  }, [dateQuery]);

  useEffect(() => {
    setRequestPromotion(props.merchantPromotion);
  }, [props.merchantPromotion]);

  let filteredData = requestPromotion && requestPromotion;
  // .sort(function (a, b) {
  //   let nameA =
  //     a &&
  //     a?.restaurant_id?.restaurant_name &&
  //     a?.restaurant_id?.restaurant_name.toLowerCase(); // ignore upper and lowercase
  //   let nameB =
  //     b &&
  //     b?.restaurant_id?.restaurant_name &&
  //     b?.restaurant_id?.restaurant_name.toLowerCase(); // ignore upper and lowercase
  //   if (nameA < nameB) {
  //     return -1;
  //   }
  //   if (nameA > nameB) {
  //     return 1;
  //   }
  //   return 0;
  // });

  if (userSort === "A-Z") {
    filteredData = filteredData.sort((a, b) => {
      if (
        a?.restaurant_id?.restaurant_name?.toLowerCase() <
        b?.restaurant_id?.restaurant_name.toLowerCase()
      )
        return -1;
      if (
        a?.restaurant_id?.restaurant_name?.toLowerCase() >
        b?.restaurant_id?.restaurant_name.toLowerCase()
      )
        return 1;
      return 0;
    });
  } else if (userSort === "Z-A") {
    filteredData = filteredData.sort((a, b) => {
      if (
        a?.restaurant_id?.restaurant_name?.toLowerCase() <
        b?.restaurant_id?.restaurant_name.toLowerCase()
      )
        return 1;
      if (
        a?.restaurant_id?.restaurant_name?.toLowerCase() >
        b?.restaurant_id?.restaurant_name.toLowerCase()
      )
        return -1;
      return 0;
    });
  } else if (userSort === "Date & Time 🠑") {
    filteredData = filteredData.sort(
      (a, b) => new Date(a?.updatedAt) - new Date(b?.updatedAt)
    );
  } else if (userSort === "Date & Time 🠓") {
    filteredData = filteredData.sort(
      (a, b) => new Date(b?.updatedAt) - new Date(a?.updatedAt)
    );
  }

  if (!isEmpty(state.search)) {
    filteredData = filteredData.filter((item) => {
      return (
        item?.restaurant_id?.restaurant_name
          .toLowerCase()
          .includes(state.search.toLowerCase()) ||
        item?.restaurant_id?._id
          .toLowerCase()
          .includes(state.search.toLowerCase())
      );
    });
  }

  const onStatusGet = (ele) => {
    let status = MERCHANT_PROMOTION_STATUS.filter(
      (el) => el.id === parseInt(ele?.status)
    );
    return status?.[0]?.title;
  };

  const onRestaurantType = (ele) => {
    let type = props.businessType.filter(
      (el) => el._id === ele?.restaurant_id?.primary_restaurant_type
    );
    return type?.[0]?.title;
  };

  const onPrimaryContact = (ele) => {
    let contact = ele.filter((el) => el.defaultChecked === true);
    return contact?.[0];
  };

  const downloadData = {
    headers: [
      { label: "S.No.", key: "serialNo" },
      { label: "Business ID", key: "businessId" },
      { label: "Business Name", key: "businessName" },
      { label: "Primary Contact", key: "primaryContact" },
      { label: "City", key: "city" },
      { label: "Area", key: "area" },
      { label: "Zip Code", key: "zipCode" },
      { label: "Business Type", key: "businessType" },
      { label: "Promotion Type", key: "promotionType" },
      { label: "Requested Tag", key: "requestedTag" },
      { label: "Status", key: "status" },
      { label: "Created Date", key: "createDate" },
    ],
    data: filteredData
      ? filteredData &&
      filteredData?.map((ele, index) => {
        return {
          serialNo: `${props?.merchantPromotionPage?.page * 10 - 10 + 1 + index++ || ""
            }`,
          businessId: `${ele?.restaurant_id?._id || " "}`,
          businessName: `${ele?.restaurant_id?.restaurant_name || " "}`,
          primaryContact: `${onPrimaryContact(ele?.restaurant_id?.point_of_contact)
              ?.firstName +
            " " +
            onPrimaryContact(ele?.restaurant_id?.point_of_contact)
              ?.lastName || " "
            } \n ${onPrimaryContact(ele?.restaurant_id?.point_of_contact)
              ?.enquiry_emails?.[0] || ""
            } \n ${onPrimaryContact(ele?.restaurant_id?.point_of_contact)
              ?.phone_numbers?.[0]?.country_code +
            " " +
            onPrimaryContact(ele?.restaurant_id?.point_of_contact)
              ?.phone_numbers?.[0]?.mobile_no || " "
            }`,

          city: `${ele?.restaurant_id?.city || " "}`,
          area: `${ele?.restaurant_id?.area || " "}`,
          zipCode: `${ele?.restaurant_id?.pinCode || " "} `,
          businessType: `${onRestaurantType(ele) || " "}`,
          promotionType: `${ele?.permotion_type || " "}`,
          requestedTag: `${ele?.tag || " "}`,
          status: `${onStatusGet(ele) || " "}`,
          createDate: `${moment(ele?.createdAt).format(
            "Do MMM YYYY hh:mm A"
          )}`,
        };
      })
      : [],
  };

  /***********************************
   * @DESC DELETE BUTTON Action
   ***********************************/
  const [deleteUomId, setDeleteUomId] = useState("");
  const openCloseDeleteModal = (data) => {
    setState({
      ...state,
      displayDeleteModal: !state.displayDeleteModal,
    });
    setDeleteUomId(data);
  };
  const handleDeleteUom = (promationId) => {
    dispatch(
      admin_delete_requested_promotion(token, promationId, onSuccessDelete)
    );
  };
  const onSuccessDelete = () => {
    Alert.success(`<h4>Unit Of Measurement Deleted Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 5000,
      offset: 35,
    });
    setState({
      ...state,
      displayDeleteModal: !state.displayDeleteModal,
    });
    dispatch(
      admin_get_requested_merchant_promotion(
        token,
        page,
        end,
        false,
        dateQuery,
        () => onSuccessPagination(),
        true,
        0,
        false,
        false,
        false
      )
    );
  };

  /***********************************
   * @DESC FILTER BUTTON ACTION
   ***********************************/
  const onClickShowFilter = (e) => {
    e.preventDefault();
    setState({
      ...state,
      displayFilter: !state.displayFilter,
      displaySearch: false,
    });
    formik.resetForm();
  };

  const formik = useFormik({
    initialValues: {
      promotionType: "",
      requestedTag: "",
    },
    onSubmit: (values) => {
      let token = props.auth.user.accessToken;
      let formData = {
        requestedTag: values.requestedTag,
        promotionType: values.promotionType,
      };
      if (formData.promotionType === "" && formData.requestedTag === "") {
        Alert.error(
          `<h4>Please fill atleast one of the following filter fields</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 5000,
            offset: 35,
          }
        );
      } else {
        dispatch(
          admin_get_requested_merchant_promotion(
            token,
            page,
            end,
            false,
            dateQuery,
            () => onSuccessFilterData(),
            true,
            0,
            formik.values.requestedTag !== "" ? true : false,
            formik.values.promotionType !== "" ? true : false,
            formik.values.requestedTag,
            formik.values.promotionType
          )
        );
      }
    },
  });

  const onSuccessFilterData = () => {
    setState({
      ...state,
      displayFilter: false,
      filterApply: true,
    });
  };

  const onClickResetFilter = () => {
    formik.resetForm();
    dispatch(
      admin_get_requested_merchant_promotion(
        token,
        page,
        end,
        false,
        dateQuery,
        () => onSuccessResetFilter(),
        true,
        0
      )
    );
  };

  const onSuccessResetFilter = () => {
    setState({
      ...state,
      filterApply: false,
      displayFilter: false,
    });
  };

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row superadmin-pending-chains-vendor">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Merchant Promotion
                  <div className="f12-400 opacity5">
                    Assign tags to the merchant, that will be displayed to the
                    user
                  </div>
                </div>
                <SuperAdminAddMerchantRequest />
              </div>
              <Row className="align-items-center">
                <Col sm={12} md={12} lg={12} xl={12}>
                  <FilterSearchSortDownload
                    searchClick={(e) => onClickSearch(e)}
                    showSearch={state.displaySearch}
                    onSearchChange={(e) => onChangeSearch(e)}
                    searchInput={state.search}
                    /******* Sort Button ******/
                    sortClick={(event) => handleClick(event)}
                    anchorEl={anchorEl}
                    handleClose={() => handleClose}
                    userFilter={userFilter}
                    setUserSort={(title) => onClickSetUserSort(title)}
                    /******* Filter Button ******/
                    showFilter={(e) => onClickShowFilter(e)}
                    /******* Download Button ******/
                    downloadFileName={"Requested Merchant Promotion Tags"}
                    headers={downloadData.headers}
                    data={downloadData.data}
                    /******* Date Filter *******/
                    onDateChangeHandler={onDateChangeHandler}
                  />
                </Col>
                {state.displayFilter ? (
                  <Col sm={12} md={12} lg={12} xl={12}>
                    <Form noValidate onSubmit={(e) => onClickSave(e)}>
                      <Col sm={12} md={12}>
                        <Row
                          className="py-3 bg-white d-flex align-items-center"
                          style={{
                            height: "22vh",
                            boxShadow: "0px 3px 6px #6E6E6E21",
                            borderRadius: 5,
                          }}
                        >
                          {/* <Col sm={4}>
                            <FormControl fullWidth variant="outlined">
                              <InputLabel id="demo-simple-select-label">
                                Business Type
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="businessType"
                                name="businessType"
                                label="Business Type"
                                className={`w-100`}
                                onChange={formik.handleChange}
                                value={formik.values.businessType}
                                onBlur={formik.handleBlur}
                              >
                                <MenuItem value="" disabled selected>
                                  Select Business Type
                                </MenuItem>
                                {businessType &&
                                  businessType?.map((data, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={data.name.toUpperCase()}
                                        name={data.name}
                                      >
                                        {data.name}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </Col> */}
                          <Col sm={4}>
                            <FormControl fullWidth variant="outlined">
                              <InputLabel id="demo-simple-select-label">
                                Promotion Type
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="promotionType"
                                name="promotionType"
                                label="Promotion Type"
                                className={`w-100`}
                                onChange={formik.handleChange}
                                value={formik.values.promotionType}
                                onBlur={formik.handleBlur}
                              >
                                <MenuItem value="" disabled selected>
                                  Select Promotion Type
                                </MenuItem>
                                {promotionType &&
                                  promotionType?.map((data, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={data.name}
                                        name={data.name}
                                      >
                                        {data.name}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </Col>
                          <Col sm={4}>
                            <FormControl fullWidth variant="outlined">
                              <InputLabel id="demo-simple-select-label">
                                Requested Tag
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="requestedTag"
                                name="requestedTag"
                                label="Requested Tag"
                                className={`w-100`}
                                onChange={formik.handleChange}
                                value={formik.values.requestedTag}
                                onBlur={formik.handleBlur}
                              >
                                <MenuItem value="" disabled selected>
                                  Select Requested Tag
                                </MenuItem>
                                {restaurantTags &&
                                  restaurantTags?.map((data, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={data.name.toUpperCase()}
                                        name={data.name}
                                      >
                                        {data.name}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </Col>
                          <Col
                            sm={12}
                            className={
                              "d-flex align-items-center justify-content-end"
                            }
                          >
                            <Button
                              variant="outline-secondary"
                              className="px-4 py-2 f14-400"
                              style={{
                                borderRadius: 5,
                              }}
                              title="Cancel"
                              onClick={(e) => onClickShowFilter(e)}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="danger"
                              className="px-4 py-2 text-white f14-400 ml-3"
                              style={{
                                borderRadius: 5,
                                backgroundColor: "#EE3A23",
                              }}
                              type="Submit"
                              title="Filter Submit"
                            >
                              Submit
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Form>
                  </Col>
                ) : null}
                {state.filterApply ? (
                  <Col
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={`text-right ${state.displayFilter ? "mt-3" : ""
                      }`}
                  >
                    <Button
                      variant="danger"
                      className="px-4 py-2 text-white"
                      style={{
                        borderRadius: 5,
                        fontSize: 12,
                        backgroundColor: "#EE3A23",
                      }}
                      type="button"
                      title="Reset Filter"
                      onClick={(e) => onClickResetFilter(e)}
                    >
                      Reset Filter
                    </Button>
                  </Col>
                ) : null}
              </Row>
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                <Table>
                  <PromotionTableHead />
                  {loading ? (
                    <div className="text-center">
                      <Loader
                        type="Bars"
                        color="#00BFFF"
                        height={100}
                        width={100}
                      />
                    </div>
                  ) : filteredData && filteredData?.length <= 0 ? (
                    <NoContent />
                  ) : (
                    !isEmpty(filteredData) &&
                    filteredData?.length > 0 &&
                    filteredData
                      .slice(start, end)
                      .map((promotionData, index) => (
                        <React.Fragment key={index}>
                          <PromotionTableBody
                            promotion={promotionData}
                            onClickDelete={() =>
                              openCloseDeleteModal(promotionData?._id)
                            }
                            restaurantTagsData={restaurantTags}
                          />
                        </React.Fragment>
                      ))
                  )}
                </Table>
              </div>
              {state.search !== "" ? (
                ""
              ) : (
                <div className="row w-100">
                  <div className="col-12">
                    {!isEmpty(filteredData) && filteredData?.length !== 0 ? (
                      <BasicPagination
                        totalRecords={
                          props?.merchantPromotionPage?.total_record
                        }
                        limit={props?.merchantPromotionPage?.per_page}
                        batch={props?.merchantPromotionPage?.page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={state.displayDeleteModal}
        onHide={openCloseDeleteModal}
        centered
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to delete this promotion?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={openCloseDeleteModal}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => handleDeleteUom(deleteUomId)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminMerchantPromotion.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
  admin_get_requested_merchant_promotion: PropTypes.func.isRequired,
  admin_delete_requested_promotion: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  merchantPromotion: state?.maintainPromotion?.getRequestPromotion?.data,
  merchantPromotionPage: state?.maintainPromotion?.getRequestPromotion,
  businessType: state?.category?.restaurant_type,
});

export default connect(mapStateToProps, {
  admin_get_requested_merchant_promotion,
  getSubCateogryWithCategoryId,
  admin_delete_requested_promotion,
})(withRouter(SuperAdminMerchantPromotion));
